/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp_RFE_module__name_"];
/******/ 	window["webpackJsonp_RFE_module__name_"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		93: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "dist/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RFEModule */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RFEModuleUi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RFEModuleUiInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RFEGlobalModule; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Class representing a RFE module that can be initialized and deinitialized
 */
var RFEModule = /** @class */ (function () {
    function RFEModule() {
    }
    /**
     * @property isRFEModule - determines if the module has new structure (rewritten in .TS) or not (old modules in .JS)
     */
    RFEModule.isRFEModule = true;
    return RFEModule;
}());

/**
 * Class representing a RFE module that is used for manipulating with Ui
 * It should be used as a base class for most of the modules that works with Ui components (Ui component is then
 * represented by RFEModuleUiInstance class)
 */
var RFEModuleUi = /** @class */ (function (_super) {
    __extends(RFEModuleUi, _super);
    function RFEModuleUi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * @prop instances - array of Ui components (RFEModuleUiInstance class)
         */
        _this.instances = [];
        return _this;
    }
    /**
     * Initialization method for the module
     * @param context - Parent element for searching target elements (HTMLElement)
     */
    RFEModuleUi.prototype.init = function (context) {
        var elements = this.getUiElements(context); // gets DOM elements
        for (var i = 0; i < elements.length; i++) {
            var el = elements[i];
            // checks if the instance for this element exists
            if (el instanceof HTMLElement && !this.findInstanceByElement(el)) { // ...if NOT, create new one
                var instance = this.createUiInstance(el);
                var initialized = instance.init();
                if (initialized) { // save an instance only if init is OK
                    this.instances.push(instance);
                }
            }
        }
    };
    /**
     * De-initialization method for the module
     * @param context - Parent element for searching target elements (HTMLElement)
     */
    RFEModuleUi.prototype.deinit = function (context) {
        for (var i = this.instances.length - 1; i >= 0; i--) {
            var instance = this.instances[i];
            // deinit instances inside of context element only
            if (instance.el === context || RFE.isChildOf(instance.el, context)) {
                instance.deinit();
                delete this.instances[i]; // delete reference
                this.instances.splice(i, 1); // remove an item from array of instances
            }
        }
    };
    /**
     * Returns components (instance of the module) that are inside of selected DOM object
     * @param context - DOM object for what we need to find related instances (HTMLElement)
     * @returns array of module instances (RFEModuleUiInstance)
     */
    RFEModuleUi.prototype.findInstancesByContext = function (context) {
        return this.instances.filter(function (instance) { return RFE.isChildOf(instance.el, context); });
    };
    /**
     * Returns component (instance of the module) related to selected DOM object
     * @param el - DOM object for what we need to find related instance (HTMLElement)
     * @returns module instance (RFEModuleUiInstance) or nothing (undefined)
     */
    RFEModuleUi.prototype.findInstanceByElement = function (el) {
        return this.instances.find(function (instance) { return instance.el === el; });
    };
    return RFEModuleUi;
}(RFEModule));

/**
 * Abstract class that represents Ui component. Each module should have own Ui class which is extended from
 * RFEModuleUiInstance and contains at least init() and deinit() methods.
 */
var RFEModuleUiInstance = /** @class */ (function () {
    /**
     * Constructor method creates basic references
     */
    function RFEModuleUiInstance(module, el) {
        this.module = module;
        this.el = el;
    }
    return RFEModuleUiInstance;
}());

/**
 * Class representing a RFE module that is used for global modules like API references
 * They have just single global instance, not related to DOM elements. It's initGlobal method is called just once.
 * WHen the module is to be initialized in the different context, it's initContext method is called
 */
var RFEGlobalModule = /** @class */ (function (_super) {
    __extends(RFEGlobalModule, _super);
    function RFEGlobalModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** @prop initialized - was the module already initialized? */
        _this.initialized = false;
        return _this;
    }
    /**
     * Initialization method for the module
     * @param context - Parent element for searching target elements (HTMLElement)
     */
    RFEGlobalModule.prototype.init = function (context) {
        if (!this.initialized) {
            this.initialized = this.initGlobal();
        }
        if (this.initialized) {
            this.initContext(context);
        }
    };
    /**
     * De-initialization method for the module
     * @param context - Parent element for searching target elements
     */
    RFEGlobalModule.prototype.deinit = function (context) {
        if (this.initialized) {
            this.deinitContext(context);
            // main de-init will be processed only for default <body> context
            if (context === window.defaultLoaderContext) {
                this.deinitGlobal();
                this.initialized = false;
            }
        }
    };
    /**
     * Optional lifecycle method for the re-initialization of the module in the different context
     * @param context - Parent element for searching target elements
     */
    RFEGlobalModule.prototype.initContext = function (context) {
        // can be implemented in the child class, by default it does nothing
    };
    /**
     * Optional lifecycle method for the de-initialization of the module in the different context
     * @param context - Parent element for searching target elements
     */
    RFEGlobalModule.prototype.deinitContext = function (context) {
        // can be implemented in the child class, by default it does nothing
    };
    return RFEGlobalModule;
}(RFEModule));



/***/ }),

/***/ 1:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModuleManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loader__ = __webpack_require__(17);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

/**
 * Class that is uset to manage all JS modules
 * it keeps track of the loaded modules and provides the functionality to load/unload/init modules for the specified
 * context
 */
var ModuleManager = /** @class */ (function () {
    function ModuleManager() {
        /** @prop dependencies - all the supported modules and it's testing methods */
        this.dependencies = {};
        /** @prop rfeModules - list of all loaded modules that supports init and deinit */
        this.rfeModules = {};
    }
    /**
     * Add dependencies to the list of supported modules
     * @param deps - array of module definition
     * @param phase - phase when the module would be loaded
     */
    ModuleManager.prototype.addDependencies = function (deps, phase) {
        if (phase === void 0) { phase = 0; }
        var phaseName = typeof phase === 'number' ? "init_" + phase : phase;
        var currentDeps = typeof this.dependencies[phaseName] === 'undefined' ? [] : this.dependencies[phaseName];
        this.dependencies[phaseName] = __spreadArrays(currentDeps, deps);
    };
    /**
     * Init method for the specified context
     * It check the context and runs all test methods for all supported modules. If the test method passes, the module
     * is then loaded and initialized for the specified context
     * @param context - The HTMLElement we want to init modules for
     */
    ModuleManager.prototype.init = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var phaseNames, autoInitRE, _i, phaseNames_1, phaseName;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        phaseNames = Object.keys(this.dependencies).sort();
                        autoInitRE = /^init(_\d+)?$/;
                        _i = 0, phaseNames_1 = phaseNames;
                        _a.label = 1;
                    case 1:
                        if (!(_i < phaseNames_1.length)) return [3 /*break*/, 4];
                        phaseName = phaseNames_1[_i];
                        if (!autoInitRE.test(phaseName)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.initPhase(phaseName, context)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Deinit method for the specified context
     * It calls the deinit method for all initialized modules and passes the context as an argument
     * @param context - The HTMLElement we want to de-init modules in
     */
    ModuleManager.prototype.deinit = function (context) {
        for (var _i = 0, _a = Object.keys(this.rfeModules); _i < _a.length; _i++) {
            var moduleName = _a[_i];
            this.deinitModule(moduleName, context);
        }
    };
    /**
     * Find the loaded module by name
     * @param moduleName - name of the module
     * @throws Error when the module is not found
     */
    ModuleManager.prototype.getModule = function (moduleName) {
        if (typeof this.rfeModules[moduleName] === 'undefined') {
            throw new Error("Module " + moduleName + " not found. It hasn't been initialized yet.");
        }
        return this.rfeModules[moduleName];
    };
    /**
     * Public alias for the private initPhase method
     * @see initPhase
     */
    ModuleManager.prototype.trigger = function (phase, context) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.initPhase(phase, context)];
            });
        });
    };
    /**
     * Runs another phase of the load process
     * @param phase - the phase name
     * @param context - The HTMLElement we want to init modules for
     */
    ModuleManager.prototype.initPhase = function (phase, context) {
        return __awaiter(this, void 0, void 0, function () {
            var moduleNames, modules, _i, moduleNames_1, moduleName;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        moduleNames = this.getActiveModuleNames(phase, context);
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__loader__["a" /* requireAll */])(moduleNames)];
                    case 1:
                        modules = _a.sent();
                        for (_i = 0, moduleNames_1 = moduleNames; _i < moduleNames_1.length; _i++) {
                            moduleName = moduleNames_1[_i];
                            this.initModule(moduleName, modules[moduleName], context);
                        }
                        if (phase === 'pageFullLoad') {
                            document.body.classList.add('js-loaded');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Initialize one module for the provided context
     * @param moduleName - name of the module
     * @param module - the module itself
     * @param context - The HTMLElement we want to init modules for
     */
    ModuleManager.prototype.initModule = function (moduleName, module, context) {
        if (typeof this.rfeModules[moduleName] !== 'undefined') {
            var instance = this.rfeModules[moduleName];
            instance.init(context);
        }
        else if (module.default && module.default.isRFEModule) {
            var instance = new module.default();
            instance.init(context);
            this.rfeModules[moduleName] = instance;
        }
    };
    /**
     * De-initialize one module
     * @param moduleName - name of the loaded module
     * @param context  - The HTMLElement we want to de-init modules in
     */
    ModuleManager.prototype.deinitModule = function (moduleName, context) {
        var instance = this.getModule(moduleName);
        instance.deinit(context);
    };
    /**
     * Returns the list of module names that should be initialized for the provided context based on its test method
     * @param phase - phase name
     * @param context - The HTMLElement we want to init modules for
     */
    ModuleManager.prototype.getActiveModuleNames = function (phase, context) {
        var moduleNames = [];
        var deps = this.dependencies[phase];
        if (deps && deps.length) {
            for (var _i = 0, deps_1 = deps; _i < deps_1.length; _i++) {
                var dep = deps_1[_i];
                if (typeof dep.test === 'undefined' || dep.test(context)) {
                    for (var _a = 0, _b = dep.dep; _a < _b.length; _a++) {
                        var singleDep = _b[_a];
                        moduleNames.push(singleDep);
                    }
                }
            }
        }
        return moduleNames;
    };
    return ModuleManager;
}());

var moduleManager = new ModuleManager();
/* harmony default export */ __webpack_exports__["a"] = (moduleManager);


/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(16)))

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return requireAll; });
/* unused harmony export require */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var callbackSequence = 0;
/**
 * Helper method to unify Ajax requests in the loader method
 * @param method - request method (GET, POST, PUT, ...)
 * @param url - requested URL
 * @returns {Promise}
 * @deprecated because this way of loading scripts prevents debugging (win10 + chrome dev. tools)
 */
function makeRequest(method, url) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open(method, url);
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                resolve(xhr.response);
            }
            else {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            }
        };
        xhr.onerror = function () {
            reject({
                status: this.status,
                statusText: xhr.statusText
            });
        };
        xhr.send();
    });
}
/**
 * Add the module to the page and evaluate it
 * @param moduleName - filename of the module where the code is located
 * @param moduleCode - Source code of the module
 */
function evalModule(moduleName, moduleCode) {
    var src = "//# sourceURL=" + moduleName + ".js\n\n" + moduleCode;
    var scriptCont = document.getElementById('scriptLoaderTarget');
    // IE9 - needs a different approach
    if (/MSIE\s/.test(navigator.userAgent) && parseFloat(navigator.appVersion.split('MSIE')[1]) < 10) {
        /* tslint:disable-next-line no-eval */
        eval(src);
    }
    else {
        var element = document.createElement('script');
        element.type = 'text/javascript';
        element.innerHTML = src;
        scriptCont && scriptCont.appendChild(element);
    }
}
/**
 * Load all the listed modules from the server in the correct order and add the source codes to the page
 * The funcion has 2 different strategies for loading modules depending on whether the loader is run
 * in the development or production mode
 * @param moduleNames - Array of module names to be loaded
 */
function loadModulesByNames(moduleNames) {
    var scriptCont = document.getElementById('scriptLoaderTarget');
    if (true) {
        var callbackName_1 = "_resourceLoaderReceiver_" + callbackSequence++;
        var script_1 = document.createElement('SCRIPT');
        script_1.src = window.appBaseUrl + "res?callback=" + callbackName_1 + (window.cacheBuster ? "&x=" + window.cacheBuster : "") + "&dependencies=" + moduleNames.join(',');
        var result = new Promise(function (resolve, reject) {
            var cleanup = function () {
                delete window[callbackName_1];
            };
            var err = function (e) {
                cleanup();
                reject(e);
            };
            window[callbackName_1] = function () {
                cleanup();
                resolve();
            };
            script_1.onerror = err;
            script_1.onabort = err;
        });
        scriptCont && scriptCont.appendChild(script_1);
        return result;
    }
    else {
        if (process.env.NODE_ENV === 'patternlab') {
            console.info("Loading modules: " + moduleNames.join(', '));
        }
        var urlTemplate_1 = window.designSetUrlRoot ?
            window.designSetUrlRoot + "/js/modules/{moduleName}.js" :
            window.appBaseUrl + "Scripts/responsive/modules/{moduleName}.js";
        var p = new Promise(function (resolve) { return resolve(); });
        var _loop_1 = function (moduleName) {
            p = p
                .then(function () {
                return new Promise(function (resolve, reject) {
                    var script = document.createElement('SCRIPT');
                    script.type = 'text/javascript';
                    script.src = urlTemplate_1.replace('{moduleName}', moduleName);
                    script.onload = resolve;
                    script.onerror = function (e) { return reject(e); };
                    scriptCont && scriptCont.appendChild(script);
                });
            })
                .catch(function (e) {
                console.error(e);
            });
        };
        for (var _i = 0, moduleNames_1 = moduleNames; _i < moduleNames_1.length; _i++) {
            var moduleName = moduleNames_1[_i];
            _loop_1(moduleName);
        }
        return p;
    }
}
/**
 * Tries to find the loaded module by name
 * the module specified by the moduleName must be already included in the page
 * @param moduleName - module to be found
 */
function getLoadedModuleByName(moduleName) {
    if (typeof window['_RFE_module_' + moduleName] !== 'undefined') {
        return window['_RFE_module_' + moduleName];
    }
    return undefined;
}
/**
 * Tries to find the loaded modules by name
 * the modules must be already loaded and included in the page
 * @param moduleNames - Array of module names to be loaded
 * @return list of requested modules
 */
function getLoadedModulesByNames(moduleNames) {
    var result = {};
    for (var _i = 0, moduleNames_2 = moduleNames; _i < moduleNames_2.length; _i++) {
        var moduleName = moduleNames_2[_i];
        var loadedModule = getLoadedModuleByName(moduleName);
        if (typeof loadedModule === 'undefined') {
            throw new Error('Module "' + moduleName + '" not found');
        }
        result[moduleName] = loadedModule;
    }
    return result;
}
/**
 * Determines, which modules are missing (are not loaded in the page)
 * @param moduleNames - Array of module names
 * @returns Array of module names that are not included in the page
 */
function getMissingModuleNames(moduleNames) {
    var result = [];
    for (var _i = 0, moduleNames_3 = moduleNames; _i < moduleNames_3.length; _i++) {
        var moduleName = moduleNames_3[_i];
        if (typeof getLoadedModuleByName(moduleName) === 'undefined') {
            result.push(moduleName);
        }
    }
    return result;
}
/**
 * Returns all the modules specified by its names
 * The function load the modules that are missing in the page and then returns all the required modules
 * @param moduleNames - Array of module names
 * @returns {Promise<Array<any>>} - Promise of the array of the modules
 */
var requireAll = function (moduleNames) { return __awaiter(void 0, void 0, void 0, function () {
    var missingModuleNames;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                missingModuleNames = getMissingModuleNames(moduleNames);
                if (missingModuleNames.length === 0) {
                    return [2 /*return*/, getLoadedModulesByNames(moduleNames)];
                }
                return [4 /*yield*/, loadModulesByNames(missingModuleNames)];
            case 1:
                _a.sent();
                return [2 /*return*/, getLoadedModulesByNames(moduleNames)];
        }
    });
}); };
/**
 * Load and return one module
 * @param moduleName - module name
 * @return module by name
 */
var require = function (moduleName) { return __awaiter(void 0, void 0, void 0, function () {
    var loadedModule;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                loadedModule = getLoadedModuleByName(moduleName);
                if (!(typeof loadedModule === 'undefined')) return [3 /*break*/, 2];
                return [4 /*yield*/, loadModulesByNames([moduleName])];
            case 1:
                _a.sent();
                return [2 /*return*/, getLoadedModuleByName(moduleName)];
            case 2: return [2 /*return*/, loadedModule];
        }
    });
}); };
/**
 * Set the important methods to the passed variable so the methods are globally available
 * @param RFE - global variable to assign important methods to
 */
var initRfeModuleLoader = function (RFE) {
    RFE.requireAll = requireAll;
    RFE.require = require;
};
window.RFE = window.RFE || {};
initRfeModuleLoader(window.RFE);


/***/ }),

/***/ 2:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export imenh */
var imenh = /** @class */ (function () {
    function imenh() {
        var _this = this;
        this.breakpoints = window.imgEnhancerBreakpoints; // the only possible image widths (loaded from configuration as global value)
        this.screenDensity = window.imageDensity;
        this.multiplied = false;
        /**
         * It will do enhancement of enhanceable elements inside of parent element.
         * @param   {HTMLElement}   context                 Parent element for searching target elements (DOM object)
         * @param   {boolean}       justNotEnhancedImages   check if '.enhance' has been applied (Boolean)
         * @param   {boolean}       [allowStretch=true]     defines, if image can be stretched (default is true) (Boolean)
         */
        this.processEnhanceableElements = function (context, justNotEnhancedImages, allowStretch) {
            if (allowStretch === void 0) { allowStretch = true; }
            var elements = _this.getEnhanceableElements(context);
            for (var i = 0; i < elements.length; i++) {
                var image = elements[i];
                _this.processEnhancement(image, justNotEnhancedImages, allowStretch);
            }
        };
        /**
         * It will do enhancement of the image
         * @param   {(HTMLImageElement)}     image                   target DOM image (HTMLImageElement)
         * @param   {boolean}                                   justNotEnhancedImages   check if '.enhance' has been applied (Boolean)
         * @param   {boolean}                                   [allowStretch=true]     defines, if image can be stretched (default is true) (Boolean)
         * @return  {string}                                                            new SRC of the image (string)
         */
        this.processEnhancement = function (image, justNotEnhancedImages, allowStretch) {
            var _a, _b, _c;
            if (allowStretch === void 0) { allowStretch = true; }
            var sourceAttr = 'src';
            var src = image.getAttribute(sourceAttr);
            var dataSrc = image.getAttribute('data-' + sourceAttr);
            var isVideo = image.nodeName === 'VIDEO';
            if (isVideo) {
                sourceAttr = 'poster';
            }
            if (!src) {
                src = dataSrc;
            }
            // video poster specific things
            if ((_a = image.parentElement) === null || _a === void 0 ? void 0 : _a.classList.contains('c-mmp__poster--video')) {
                //video frame or uploaded image
                if (src === null || src === void 0 ? void 0 : src.includes('_tv')) {
                    src = src.replace('_b1', '').replace('_r1', '_r0');
                }
                else {
                    // get aspect ratio
                    var aspectRatio = (_c = (_b = $dom.ancestor(image, '.c-mmp').querySelector('video')) === null || _b === void 0 ? void 0 : _b.getAttribute('data-aspect-ratio')) === null || _c === void 0 ? void 0 : _c.split('/');
                    // vertical teaser
                    if (image.classList.contains('c-mmp__poster-image-v') && aspectRatio) {
                        src = src.replace(/_r\d/i, '');
                        if (src.includes('_h')) {
                            src = src.replace(/_w\d*/i, '_w' + aspectRatio[0]);
                        }
                        else {
                            src = src.replace(/_w\d*/i, '_w' + aspectRatio[0] + '_h' + aspectRatio[1]);
                        }
                    }
                    if (image.classList.contains('c-mmp__poster-image-h') && aspectRatio) {
                        //horizontal teaser
                        if ((RFE.getResponsiveState() === 'xs' || $dom.ancestor(image, '.c-mmp--embed-vertical')) && !src.includes('_h')) {
                            // make it vert
                            image.classList.remove('enhanced');
                            src = src.replace(/_r\d/i, '');
                            src = src.replace(/_w\d*/i, '_w' + aspectRatio[0] + '_h' + aspectRatio[1]);
                        }
                        if (RFE.getResponsiveState() !== 'xs' || $dom.ancestor(image, '.c-mmp--embed-vertical')) {
                            // make it horizontal
                            src = src.replace(/_r\d/i, '');
                            src = src.replace(/_h\d*/i, '').replace(/_w\d*/i, src.match(/_w\d*/i) + '_r1');
                            image.classList.remove('enhanced');
                        }
                    }
                }
            }
            var newUrl = _this.getRightImageURL(src, image, justNotEnhancedImages, allowStretch);
            if (typeof newUrl === 'string') {
                (function (image) {
                    // RESP-4543: this timeout needs to be set because of smooth lazy load in Chrome
                    setTimeout(function () {
                        if (!$dom.ancestor(image, '.img-wrap--infographics')) {
                            $dom.addClass(image, 'enhanced');
                        }
                        else {
                            $dom.addClass(image, 'enhanced--infographic');
                        }
                    }, 10);
                })(image);
                if (isVideo) {
                    image.setAttribute('poster', newUrl);
                }
                else {
                    image.src = newUrl;
                }
            }
            return image.src;
        };
        /**
         * Decide if image will be enhanced.
         * @param   {string}                                    src                     Original SRC (String)
         * @param   {(HTMLImageElement | HTMLVideoElement)}     image                   Image object (DOM object)
         * @param   {boolean}                                   justNotEnhancedImages   check if '.enhance' has been applied (Boolean)
         * @param   {boolean}                                   [allowStretch=true]     defines, if image can be stretched (default is true) (Boolean)
         * @return  {(string | null | boolean)}                                         Returns {string} new src or {null} if the src given is good enough. If there is any problem (can not process source) it returns {false}.
         */
        this.getRightImageURL = function (src, image, justNotEnhancedImages, allowStretch) {
            var _a, _b, _c;
            if (allowStretch === void 0) { allowStretch = true; }
            var origin = /_w([0-9]{2,5})/g.exec(src);
            if (!origin || !origin[1]) { // The URL given is not able to be parsed
                // var title = 'N/A'
                return false;
            }
            else if ($dom.hasClass(image, 'live-tracker-image')) { // live tracker image not to be displayed
                return false;
            }
            else { // the url given is ready to be parsed
                if (allowStretch === undefined) {
                    allowStretch = true;
                }
                var originWidth = parseInt(origin[1]);
                var areaWidth = image.offsetWidth;
                var firstParent = $dom.ancestor(image);
                if (firstParent.className.indexOf('thumb') > -1) {
                    // PANGEA-7065 Image Display Problems - fixes issue with the small image
                    // for some reason the image without src attribute has width 16 no matter of the CSS.
                    // In this case we use the width of the parent element
                    areaWidth = Math.max(firstParent.offsetWidth, areaWidth);
                }
                var secondParent = $dom.ancestor(firstParent);
                if (secondParent && secondParent.className.indexOf('c-lightbox__img') > -1) {
                    // for the lightbox we need to get dimensions from next parent element (wrapper for lightbox image)
                    areaWidth = Math.max(secondParent.offsetWidth, areaWidth);
                }
                // don't enhance images which are not visibble at the moment, hidden on newslayout for example
                if (!areaWidth) {
                    return false;
                }
                // fix small images after click on load more button (photoblog page)
                if ($dom.hasClass(document.body, 'pg-photoblog') && typeof image === 'object' && areaWidth === 0) {
                    return false;
                }
                var areaWidthInfo = areaWidth * 2;
                var wantedWidth = -1; // originally was (originWidth * 3);
                var oneUp = -1;
                var credFSMultipl = 0;
                var srcExt = /\..{1,5}$/g.exec(src);
                if (_this.screenDensity) {
                    if (window.devicePixelRatio) {
                        if (window.devicePixelRatio > 1) {
                            credFSMultipl = Math.ceil(window.devicePixelRatio);
                            areaWidth = Math.floor(areaWidth * window.devicePixelRatio);
                            _this.multipyBreakPoints(window.devicePixelRatio);
                        }
                    }
                    else {
                        credFSMultipl = Math.ceil(_this.screenDensity);
                        areaWidth = areaWidth * _this.screenDensity;
                        _this.multipyBreakPoints(_this.screenDensity);
                    }
                    if (credFSMultipl && srcExt && srcExt[0]) {
                        var hasFontMulti = src.match(/_d\d/g) || [];
                        src = hasFontMulti.length
                            ? src.replace(/_d\d/g, '_d' + credFSMultipl)
                            : src.replace(srcExt[0], '_d' + credFSMultipl + srcExt[0]);
                    }
                }
                // looking for the best breakpoints
                for (var j = _this.breakpoints.length - 1; wantedWidth === -1 && j > -1; j--) {
                    var breakpoint = _this.breakpoints[j];
                    if (breakpoint <= areaWidth) { // ok, we found a right gap
                        if ((oneUp !== -1 && areaWidth > breakpoint * 1.1) || areaWidth === 0) { // if the size is more than 110% of the breakpoint take the bigger
                            wantedWidth = oneUp;
                        }
                        else {
                            wantedWidth = breakpoint; // take the breakpoint because it's acceptable
                        }
                    }
                    oneUp = breakpoint; // save previous breakpoint
                }
                if (secondParent && secondParent.className.indexOf('img-wrap--infographics') > -1) {
                    wantedWidth = areaWidthInfo; // setting double for static infographics
                }
                var pos = origin.index + 2; // '2' means position - '_w'
                var loadable = _this.canBeLoaded(originWidth, areaWidth, wantedWidth, src, image, justNotEnhancedImages);
                if (wantedWidth > -1 && loadable) { // load that finally or not ?
                    // change quality if it is so small
                    src = src.replace('_q10', '');
                    var aspectRatio = (_c = (_b = (_a = $dom.ancestor(image, '.c-mmp')) === null || _a === void 0 ? void 0 : _a.querySelector('video')) === null || _b === void 0 ? void 0 : _b.getAttribute('data-aspect-ratio')) === null || _c === void 0 ? void 0 : _c.split('/');
                    if (src.includes('_h') && (aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.length) === 2) {
                        var retValWithHeight = src.substring(0, pos) + wantedWidth.toString() + ((!allowStretch) ? '_n' : '') + src.substring(pos + originWidth.toString().length);
                        var resultHeight = wantedWidth * (aspectRatio[1] / aspectRatio[0]);
                        return retValWithHeight.replace(/_h\d*/i, '_h' + Math.ceil(resultHeight));
                    }
                    var retVal = src.substring(0, pos) + wantedWidth.toString() + ((!allowStretch) ? '_n' : '') + src.substring(pos + originWidth.toString().length);
                    return retVal;
                }
                else {
                    return null;
                }
            }
        };
        this.multipyBreakPoints = function (multiplicator) {
            if (!_this.multiplied) {
                var breakpointTempArr = [];
                for (var a = 0; a < _this.breakpoints.length; a++) {
                    var value = Math.floor(_this.breakpoints[a] * multiplicator);
                    breakpointTempArr.push(value);
                }
                _this.breakpoints = breakpointTempArr;
                _this.multiplied = true;
            }
        };
        /**
         * Finds enhanceable elements in context of document body which were not enhanced yet and process them.
         * Images can be stretched.
         */
        this.viewportChangeEvent = function () {
            _this.processEnhanceableElements(document.body, true, true);
        };
        /**
         * Finds enhanceable elements in context of document body and process them.
         * Images can be stretched.
         */
        this.firstInitEvent = function () {
            _this.processEnhanceableElements(document.body, true, true);
        };
        /**
         * Returns all image and video element from target element which can be enhanced.
         * @param   {HTMLElement}           context     Parent element for searching target elements (HTMLElement)
         * @return  {Array<HTMLElement>}                NodeList or array of HTML elements
         */
        this.getEnhanceableElements = function (context) {
            var allElements = context.querySelectorAll('img, video[poster]');
            var enhancerElements = []; // filtered items
            for (var i = 0; i < allElements.length; i++) {
                var image = allElements[i];
                if (!image) {
                    continue;
                }
                if (image.nodeName === 'IMG') {
                    image.getBoundingClientRect().height && image.setAttribute('height', image.getBoundingClientRect().height.toFixed());
                    image.getBoundingClientRect().width && image.setAttribute('width', image.getBoundingClientRect().width.toFixed());
                }
                // disable the processing for specific images
                if ($dom.hasClass(image, 'dont-enhance')) {
                    continue;
                }
                // check if the image is visible (in the viewpoint or upper)
                if (!_this.isWithinViewport(image) && !RFE.isMobile.Opera()) {
                    continue;
                }
                enhancerElements.push(image); // the image is enhanceable
            }
            return enhancerElements;
        };
        /**
         * Determines whether an element is within the viewport
         *
         * @param   {Element}   el   Tested HTML element (DOM object)
         * @return  {boolean}       TRUE/FALSE if the element is within the viewport or not (boolean)
         */
        this.isWithinViewport = function (el) {
            var rect = el.getBoundingClientRect();
            return rect.top < (window.innerHeight || document.body.clientHeight) && rect.left < (window.innerWidth || document.body.clientWidth);
        };
        /**
         * Determines if the image can be loaded (enhanced).
         * @param   {number}                                    originWidth             Current Image size (Number)
         * @param   {number}                                    areaWidth               Node IMG size (Number)
         * @param   {number}                                    wantedWidth             New decided width (Number)
         * @param   {string}                                    src                     Original SRC (String)
         * @param   {(HTMLImageElement | HTMLVideoElement)}     img                     Image object (DOM object)
         * @param   {boolean}                                   justNotEnhancedImages   check if '.enhance' has been applied (Boolean)
         * @return  {boolean}                                                           Returns Boolean. If returns true the image will be loaded
         * @todo    Constants for areas: is in viewport, is the connection fast, ...
         */
        this.canBeLoaded = function (originWidth, areaWidth, wantedWidth, src, img, justNotEnhancedImages) {
            if (src !== img.src) { //img.classList.contains('c-mmp__poster-image-h')
                return true;
            }
            if (src.indexOf('_q10') > -1) { // wrong image quality, to be enhanced
                return true;
            }
            if (originWidth === wantedWidth) { // don't load when it's already same sized
                return false;
            }
            else if (justNotEnhancedImages && $dom.hasClass(img, 'enhanced')) { // it is already enhanced, skip that
                return false;
            }
            else if (originWidth / wantedWidth >= 0.9 && !!img.src) { // don't load when it's only less that 10% smaller
                return false;
            }
            return true; // let's load the image
        };
    }
    /**
     * Initialization of module. This module is expected to be used as single instance on page.
     * @return  {boolean}      TRUE/FALSE if the initialization was successful or not (boolean)
     */
    imenh.prototype.initGlobal = function () {
        this.enhancerInitTimeout = setTimeout(this.firstInitEvent, 0);
        //this.firstInitEvent()
        window.addEventListener('scrollStartRfe', this.viewportChangeEvent);
        window.addEventListener('scrollEndRfe', this.viewportChangeEvent);
        window.addEventListener('resize', this.viewportChangeEvent);
        window.addEventListener('showOverlayRfe', this.viewportChangeEvent);
        window.addEventListener('playerRendered', this.viewportChangeEvent);
        // the instance of module has been initialized => return TRUE
        return true;
    };
    /**
     * De-initialization of module
     */
    imenh.prototype.deinitGlobal = function () {
        clearTimeout(this.enhancerInitTimeout);
        window.removeEventListener('scrollStartRfe', this.viewportChangeEvent);
        window.removeEventListener('scrollEndRfe', this.viewportChangeEvent);
        window.removeEventListener('resize', this.viewportChangeEvent);
        window.removeEventListener('showOverlayRfe', this.viewportChangeEvent);
        window.removeEventListener('playerRendered', this.viewportChangeEvent);
    };
    return imenh;
}());

var imenhc = new imenh();
/* harmony default export */ __webpack_exports__["a"] = (imenhc);


/***/ }),

/***/ 3:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = getAnalyticsPageData;
/* harmony export (immutable) */ __webpack_exports__["h"] = trackAnalyticsEvent;
/* harmony export (immutable) */ __webpack_exports__["i"] = trackAnalyticsView;
/* harmony export (immutable) */ __webpack_exports__["e"] = FireTealiumEvent;
/* harmony export (immutable) */ __webpack_exports__["b"] = FireAnalyticsTagEventOnSearch;
/* harmony export (immutable) */ __webpack_exports__["c"] = FireAnalyticsTagEventOnSearchResultItemClick;
/* harmony export (immutable) */ __webpack_exports__["a"] = FireAnalyticsTagEventOnDownload;
/* harmony export (immutable) */ __webpack_exports__["f"] = FireTealiumEventOnDownload;
/* harmony export (immutable) */ __webpack_exports__["d"] = FireAnalyticsTagEventQuiz;
// debug logging only if ?analyticsDebug=1 is present in the URL of the current window or parent window (in the case of iframe)
var _isAnalyticsDebugEnabled = (function () {
    var hasParam = function (w) {
        try {
            var search = w && w.location && w.location.search ? w.location.search : false;
            if (typeof search !== 'string') {
                return false;
            }
            var params = new URLSearchParams(search);
            return params.get('analyticsDebug') === 'true';
        }
        catch (_a) {
            return false; // cross-origin parent apod.
        }
    };
    // actual window
    if (hasParam(window)) {
        return true;
    }
    // parent
    try {
        if (window.parent && window.parent !== window) {
            if (hasParam(window.parent)) {
                return true;
            }
        }
    }
    catch (_a) {
        // ignore cross-origin
    }
    return false;
})();
function getAnalyticsPageData() {
    if (window.analyticsData) {
        return window.analyticsData; // generic data container (Google format)
    }
    if (window.utag_data) {
        return window.utag_data; // temporal fallback data, it should be removed with Tealium
    }
    return {};
}
/**
 * ===================================================================================
 *  Central Analytics Dispatcher of all events for all platforms
 * ===================================================================================
 */
function trackAnalyticsAction(data) {
    if (_isAnalyticsDebugEnabled) {
        console.log('---- \n trackAnalyticsAction', data);
    }
    if ((!data.event || data.event.trim() === '') && data.on_page_event) {
        data.event = data.on_page_event;
    }
    // make sure that a property "event" is sent (GTM only reacts when your dataLayer.push() includes the special key: event: "something")
    if (!data.event || data.event.trim() === '') {
        console.error('trackAnalyticsAction: invalid event attribute.', { data: data });
        return;
    }
    // 1. Sends data to the Google Tag Manager Data Layer
    var dataLayer = window.dataLayer || [];
    if (_isAnalyticsDebugEnabled) {
        console.log('sending dataLayer.push()');
    }
    dataLayer.push(data);
    // 2. Sends data to Tealium
    var uTag = window.utag;
    if (uTag) {
        // Tealium uses different methods for page views and other events:
        if (data.page_name) { // It's "page view" if the page_name is defined
            if (_isAnalyticsDebugEnabled) {
                console.log('sending uTag.view()');
            }
            uTag.view(data);
        }
        else {
            if (_isAnalyticsDebugEnabled) {
                console.log('sending uTag.link()');
            }
            uTag.link(data); // all other events
        }
    }
}
// main analytics tracking method for events
function trackAnalyticsEvent(eventData) {
    trackAnalyticsAction(eventData);
}
// main analytics tracking method for page views
function trackAnalyticsView(eventData) {
    if (!eventData.page_name || eventData.page_name.trim() === '') {
        console.error('trackAnalyticsView: invalid page_name attribute.', { eventData: eventData });
        return;
    }
    trackAnalyticsAction(eventData);
}
// --- Aliases for backward compatibility ---
function FireTealiumEvent(event) {
    trackAnalyticsEvent(event);
}
function FireAnalyticsTagEventOnSearch(searchEvent, searchKeyword) {
    var eventData = { event: searchEvent, on_page_event: searchEvent, search_kw: searchKeyword };
    if (searchEvent === 'search_refine') {
        var arr = searchKeyword.split('|');
        eventData = { event: searchEvent, on_page_event: 'search_refine', refine_content: arr[2], refine_type: arr[1], search_kw: arr[0] };
    }
    else if (searchEvent === 'search_suggested') {
        eventData = { event: searchEvent, on_page_event: 'search', search_kw: searchKeyword, suggested_search: 'true' };
    }
    trackAnalyticsEvent(eventData);
}
function FireAnalyticsTagEventOnSearchResultItemClick(articleTitle, rank) {
    trackAnalyticsEvent({ event: 'search_click', on_page_event: 'search_click', search_item: articleTitle, search_result_rank: rank });
}
function FireAnalyticsTagEventOnDownload(link, mediaType, contentId, mediaName, mediaLength, byline, pubYear, pubMonth, pubDay) {
    var fileUrl = link.href;
    trackAnalyticsEvent({
        byline: byline,
        content_id: contentId,
        download_location: window.location.href,
        filename: fileUrl,
        media_filetype: fileUrl.substring(fileUrl.lastIndexOf('.') + 1).replace(/\?.*$/, ''),
        media_length: mediaLength,
        media_name: mediaName,
        media_type: mediaType,
        event: 'download_start',
        on_page_event: 'download_start',
        pub_day: pubDay,
        pub_month: pubMonth,
        pub_year: pubYear
    });
}
function FireTealiumEventOnDownload(link, mediaType, contentId, mediaName, mediaLength, byline, pubYear, pubMonth, pubDay) {
    FireAnalyticsTagEventOnDownload(link, mediaType, contentId, mediaName, mediaLength, byline, pubYear, pubMonth, pubDay);
}
function FireAnalyticsTagEventQuiz(surveyEvent, quizTitle) {
    trackAnalyticsEvent({ event: surveyEvent, on_page_event: surveyEvent, surveyName: quizTitle });
}
// --- Exports for usage in other modules ---
/* unused harmony default export */ var _unused_webpack_default_export = ({
    getAnalyticsPageData: getAnalyticsPageData,
    trackAnalyticsEvent: trackAnalyticsEvent,
    trackAnalyticsView: trackAnalyticsView,
    FireAnalyticsTagEventOnDownload: FireAnalyticsTagEventOnDownload,
    FireAnalyticsTagEventOnSearch: FireAnalyticsTagEventOnSearch,
    FireAnalyticsTagEventOnSearchResultItemClick: FireAnalyticsTagEventOnSearchResultItemClick,
    FireAnalyticsTagEventQuiz: FireAnalyticsTagEventQuiz,
    FireTealiumEvent: FireTealiumEvent,
    FireTealiumEventOnDownload: FireTealiumEventOnDownload
});


/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_module__ = __webpack_require__(0);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

/**
 * Helper module which copies text from field to clipboard and (optionally) displays element with the result message.
 * @todo    possible duplication of RFE.multimediaPlayerUtils.copyToClipboard
 *          VS: it's not duplication anymore, but it should be implemented into the player utils,
 *          but we might need to implement to multimediPlayer at some point
 */
var CopyToClipboard = /** @class */ (function (_super) {
    __extends(CopyToClipboard, _super);
    function CopyToClipboard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.navigatorClipboard = navigator.clipboard;
        /**
         * Copies text from field to clipboard and (optionally) displays element with the result message.
         * @param   {string}   elementId            id ID of HTML element to copy text from to clipboard (string)
         * @param   {string}   [messageId=null]     msg ID of element to display on successful copy (ignored if null) (string | null)
         * @todo    change messageId parameter from ID (string) to element (HTMLElement)
         */
        _this.copyToClipboard = function (element, messageEL) {
            if (messageEL === void 0) { messageEL = null; }
            return __awaiter(_this, void 0, void 0, function () {
                var copySuccess;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!element) {
                                return [2 /*return*/, false];
                            }
                            element.focus();
                            element.setSelectionRange(0, element.value.length);
                            copySuccess = false;
                            if (!(document.queryCommandEnabled('copy') && !this.navigatorClipboard)) return [3 /*break*/, 1];
                            copySuccess = this.copyNoApi(copySuccess);
                            this.showMessage(copySuccess, messageEL);
                            return [3 /*break*/, 4];
                        case 1:
                            if (!this.navigatorClipboard) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.copyWithApi(element)];
                        case 2:
                            copySuccess = _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            console.error('Can not copy to clipboard');
                            _a.label = 4;
                        case 4: return [2 /*return*/, Promise.resolve(copySuccess)];
                    }
                });
            });
        };
        /**
         * for browsers which don't support Clipboard API (https://www.w3.org/TR/clipboard-apis/#async-clipboard-api
         */
        _this.copyNoApi = function (copySuccess) {
            copySuccess = document.execCommand('copy'); // run command to copy selected text to clipboard
            return copySuccess;
        };
        // for browsers which do support Clipboard API
        _this.copyWithApi = function (inputElement) { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.navigatorClipboard.writeText(inputElement.value).then(function () {
                            return true;
                        }, function () {
                            console.error('Unable to write to clipboard.');
                            return false;
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        }); };
        /**
         * show message
         */
        _this.showMessage = function (copySuccess, messageEl) {
            if (copySuccess && messageEl) {
                messageEl.style.display = 'block';
            }
        };
        return _this;
    }
    /**
     * Initialization of module. This module is expected to be used as single instance on page.
     * @return  {boolean}      TRUE/FALSE if the initialization was successful or not (boolean)
     */
    CopyToClipboard.prototype.initGlobal = function () {
        // the instance of module has been initialized => return TRUE
        return true;
    };
    /**
     * De-initialization of module
     */
    CopyToClipboard.prototype.deinitGlobal = function () { };
    /**
     * Initialization of the module inside of context
     * @param   {HTMLElement}   context   Parent element for searching target elements (HTMLElement)
     */
    CopyToClipboard.prototype.initContext = function (context) { };
    /**
     * De-initialization of module inside of context
     * @param   {HTMLElement}   context   Parent element for searching target elements (HTMLElement)
     */
    CopyToClipboard.prototype.deinitContext = function (context) { };
    return CopyToClipboard;
}(__WEBPACK_IMPORTED_MODULE_0__helpers_module__["a" /* RFEGlobalModule */]));
/* harmony default export */ __webpack_exports__["default"] = (CopyToClipboard);


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_module__ = __webpack_require__(0);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

/**
 * This module is used for the functionality of smooth scrolling to selected anchor or element.
 */
var SmoothScroll = /** @class */ (function (_super) {
    __extends(SmoothScroll, _super);
    function SmoothScroll() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Selects and returns related HTML elements
     * @param   {HTMLElement}                       context     Parent element for searching target elements (HTMLElement)
     * @return  {(NodeList | Array<HTMLElement>)}               NodeList or array of HTML elements
     */
    SmoothScroll.prototype.getUiElements = function (context) {
        var links = context.querySelectorAll("a[href^='#']");
        var elements = [];
        for (var i = 0; i < links.length; i++) {
            var link = links[i];
            var href = link.getAttribute('href');
            if (link.getAttribute('data-disable-smooth-scroll') || !href || href.length < 2 || href.indexOf('#') !== 0) {
                continue; // not valid or excluded anchor link => skip it
            }
            elements.push(link); // adds to the array with filtered items
        }
        return elements;
    };
    /**
     * Creates single Ui instance from DOM element
     * @param   {HTMLElement}       el   DOM object from witch we want to create new instance (HTMLElement)
     * @return  {SmoothScrollUi}         module instance (RFEModuleUiInstance)
     */
    SmoothScroll.prototype.createUiInstance = function (el) {
        return new SmoothScrollUi(this, el);
    };
    return SmoothScroll;
}(__WEBPACK_IMPORTED_MODULE_0__helpers_module__["b" /* RFEModuleUi */]));
/* harmony default export */ __webpack_exports__["default"] = (SmoothScroll);
// Ui for one instance of module
var SmoothScrollUi = /** @class */ (function (_super) {
    __extends(SmoothScrollUi, _super);
    function SmoothScrollUi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.steps = 50; // how many steps per duration time?
        _this.topOffset = 150; // offset from top of window [px]
        _this.duration = 500; // time of animation [ms]
        /**
         * It will do smooth scroll animation to selected DOM element.
         * @param   {HTMLElement}   element   Target element (HTMLElement).
         */
        _this.scrollToElement = function (element) {
            if (element) {
                _this.animate(window.pageYOffset, RFE.getOffsetFromBody(element).y - _this.topOffset, _this.steps);
            }
        };
        /**
         * Animation of smooth scrolling.
         * @param   {number}   from    Start vertical position of animation. (number)
         * @param   {number}   to      End vertical position of animation. (number)
         * @param   {number}   steps   Number of steps. (number)
         */
        _this.animate = function (from, to, steps) {
            var piece = (to - from) / steps;
            var i = 0;
            var iteration = function () {
                var pos = from + (i * piece);
                document.documentElement.scrollTop = pos;
                document.body.scrollTop = pos;
                if (++i <= steps) {
                    _this.iterationTimeout = setTimeout(iteration, _this.duration / (steps));
                }
            };
            iteration();
        };
        /**
         * Click event on anchor link. It will create smooth scroll animation.
         * @return  {(boolean | void)}      Returns false to prevent click action (boolean)
         */
        _this.anchorLinkClick = function () {
            var link = _this.el;
            if (!link) {
                return;
            }
            var href = link.getAttribute('href');
            var name = href.substr(1);
            var target = document.getElementById(name);
            if (!target) { // try to find <a> element with related 'name' attribute
                var anchors = document.getElementsByTagName('a');
                for (var k = 0; k < anchors.length; k++) {
                    var anchor = anchors[k];
                    if (anchor.name === name) {
                        target = anchor;
                    }
                }
            }
            if (target) {
                _this.scrollToElement(target);
            }
            // event tracking
            // if (name === 'comments') {
            //     trackAnalyticsEvent({ on_page_event: 'smooth_scroll-#' + name });
            // }
            return false;
        };
        return _this;
    }
    /**
     * Initialization of single instance of the module
     * @return  {boolean}      TRUE/FALSE if the initialization was successful or not (boolean)
     */
    SmoothScrollUi.prototype.init = function () {
        this.el.addEventListener('click', this.anchorLinkClick, false);
        // the instance of module has been initialized => return TRUE
        return true;
    };
    /**
     * De-initialization of single instance of the module
     */
    SmoothScrollUi.prototype.deinit = function () {
        this.el.removeEventListener('click', this.anchorLinkClick, false);
        clearTimeout(this.iterationTimeout);
    };
    return SmoothScrollUi;
}(__WEBPACK_IMPORTED_MODULE_0__helpers_module__["c" /* RFEModuleUiInstance */]));


/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(15);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ })

/******/ });


// WEBPACK FOOTER //
// commons.js